import { NextPlan } from "../../models/next-plan.model";
import Backdrop from "../backdrop/backdrop";
import PricingPaywall from "./pricing-paywall";
import TriggeredPaywall from "./triggered-paywall";


export interface PaywallProps {
  handleClose: () => void;
  handleAccept: () => void;
  plans: NextPlan[];
  triggered?: boolean;
}

const Paywall: React.FC<PaywallProps> = ({
  handleClose,
  handleAccept,
  plans,
  triggered,
}) => {

  return (
    <>
      <Backdrop isShown={true} toggle={() => { }} zIndex={599} />
      {!triggered ? (
        <PricingPaywall 
          handleClose={handleClose}
          handleAccept={handleAccept}
          plans={plans}
        />
      ) : (
        <TriggeredPaywall handleClose={handleClose} />
      )}
    </>
  );
};

export default Paywall;
